import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { provideCommonAngularModules, provideRouterAngular } from '@share/provideAngularModules';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalService } from 'ng-zorro-antd/modal';
import { WhatsappEmbeddedSignupService } from '@app/services/whatsappEmbeddedSignup.service';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgTemplateOutlet, NgIf } from '@angular/common';
import { RoutingService } from '@app/services/routing.service';
import { Menu } from '@app/share/type/menu';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NotificationEventService } from '@app/services/notificationEvent.service';
import { takeUntil } from 'rxjs';
import { SelfDestroyService } from '@app/services/selfDestroy.service';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [NzMenuModule, ...provideRouterAngular(), TranslatePipe, NzIconModule, NgTemplateOutlet, ...provideCommonAngularModules()],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less'],
  providers: [SelfDestroyService]
})
export class SidebarComponent implements OnInit {
  router = inject(Router);
  nzModalService = inject(NzModalService);
  nzMessageService = inject(NzMessageService);
  routingService = inject(RoutingService);
  translate = inject(TranslateService);
  whatsappEmbeddedSignupService = inject(WhatsappEmbeddedSignupService);
  notificationEventService = inject(NotificationEventService);
  destroyService = inject(SelfDestroyService, { self: true });
  isNowUrl = "";
  menus: Array<Menu & { isOpen?: boolean, isSelected?: boolean }> = []
  currentUrl = "";
  isFontWeight = false;

  ngOnInit() {
    const pathname = window.location.pathname;
    this.routingService.menus$.subscribe(menus => {
      this.menus = menus;
      this.menus.forEach(item => {
        item.isOpen = pathname.startsWith('/new/' + item.path);
        item.isSelected = pathname.startsWith('/new/' + item.fullPath);
      })
    });
    this.notificationEventService.languageEvent.pipe(takeUntil(this.destroyService)).subscribe((currentLang: string) => {
      if(currentLang != 'zh' && currentLang != 'zh_TW') {
        this.isFontWeight = true;
      } else {
        this.isFontWeight = false;
      }
    })
  }

  /** visible：0 显示，1 隐藏（与 Menu 类型注释一致） */
  visibleMenus(children: Menu[] | undefined): Array<Menu & { isOpen?: boolean, isSelected?: boolean }> {
    return (children ?? []).filter(m => m.visible !== '1') as Array<Menu & { isOpen?: boolean, isSelected?: boolean }>;
  }

  handleMenuClick(item: Menu & { isOpen?: boolean, isSelected?: boolean }) {
    if (item.isFrame === '0') {
      if (location.origin.indexOf("localhost") > -1) {
        window.open("http://localhost:5505" + item.path, "_blank");
      } else {
        window.open(item.path, "_blank");
      }
    } else if (item.menuType === 'W') {
      item['isSelected'] = true;
      this.router.navigate([item.fullPath]);
    } else {
      this.menus.forEach(menu => {
        if (menu.menuType === 'W') {
          menu.isSelected = false
        }
      })
    }
  }
} 